import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSearchParams } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import { requestPortalSession } from '../services/backendApi';
import { trackLandingEvent } from '../services/analytics';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 60px 20px;
  text-align: center;
`;

const SuccessIcon = styled.div`
  font-size: 5rem;
  color: #22c55e;
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #333;
`;

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 2rem;
  background-color: #4f46e5;
  color: white;
  font-weight: 600;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #4338ca;
  }
`;

const SubscriptionSuccess: React.FC = () => {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const [sessionId, setSessionId] = useState<string | null>(null);

  useEffect(() => {
    const value = searchParams.get('session_id');
    setSessionId(value);
    trackLandingEvent('subscription_success_view', { has_session_id: Boolean(value) });
  }, [searchParams]);

  const handleManageBilling = async () => {
    if (!sessionId) return;

    try {
      trackLandingEvent('billing_portal_click', { placement: 'subscription_success' });
      const data = await requestPortalSession({
        session_id: sessionId,
        return_url: `${window.location.origin}/mySubscription`
      });
      if (data && data.url) {
        window.location.href = data.url; // 重定向到 Stripe 订单管理页面
      } else {
        throw new Error(t('subscriptionSuccess.invalidPortalUrl'));
      }
    } catch (error) {
      console.error('Portal session error:', error);
      alert(t('subscriptionSuccess.portalFailed'));
    }
  };

  return (
    <Container>
      <SuccessIcon>
        <FaCheckCircle />
      </SuccessIcon>
      
      <Title>{t('subscriptionSuccess.title')}</Title>
      
      <Button onClick={handleManageBilling}>
        {t('subscriptionSuccess.manageBilling')}
        <FaArrowRight />
      </Button>
    </Container>
  );
};

export default SubscriptionSuccess; 
